import { VerticalLayout } from "../components/layout";
import { icon } from "../functions/icons";

 export function ShowLayoutError({ iconType, errorTitle, message }) {
    return (
      <VerticalLayout className="center-all complete-height">
        <span
          className="small-standard-margin"
          style={{ color: "var(--grey-500)" }}
        >
          {icon(iconType, 96)}
        </span>
        <span style={{ color: "var(--grey-800)" }}>{errorTitle}</span>
        <br />
        {message && (
          <span style={{ color: "var(--grey-600)", fontSize: "14px" }}>
            {message}
          </span>
        )}
      </VerticalLayout>
    );
  }
